import React, { useState } from 'react';
import { SwipeableDrawer, Drawer, List, ListItem, ListItemIcon, ListItemText, IconButton, Box } from '@mui/material';
import { Home,  People, History, LocalPharmacy, Menu } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const SideNav = () => {
    const [open, setOpen] = useState(false);

    const toggleDrawer = (state) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(state);
    };

    const drawerContent = (
        <Box
            sx={{ width: 250, mt: 8 }}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
        <List>
            <ListItem button component={Link} to="/home">
                <ListItemIcon><Home /></ListItemIcon>
                <ListItemText primary="Home" />
            </ListItem>
            <ListItem button component={Link} to="/view-patients">
                <ListItemIcon><People /></ListItemIcon>
                <ListItemText primary="Pacientes" />
            </ListItem>
            <ListItem button component={Link} to="/historias/2">
                <ListItemIcon><History /></ListItemIcon>
                <ListItemText primary="Historia Clínica" />
            </ListItem>
            <ListItem button component={Link} to="/historias-hoy">
                <ListItemIcon><History /></ListItemIcon>
                <ListItemText primary="Historias de Hoy" />
            </ListItem>
            <ListItem button component={Link} to="/diagnosticos-tratamientos">
                <ListItemIcon><History /></ListItemIcon>
                <ListItemText primary="Bioestadística" />
            </ListItem>
            <ListItem button component={Link} to="/drugs">
                <ListItemIcon><LocalPharmacy /></ListItemIcon>
                <ListItemText primary="Fármacos" />
            </ListItem>
            <ListItem button component="a" href="https://sedimec.dictamenmedico.com/sedimec-med/login/auth" target="_blank" rel="noopener noreferrer">
                <ListItemIcon><History /></ListItemIcon>
                <ListItemText primary="SEDIMEC" />
            </ListItem>
            <ListItem button component="a" href="https://recetadigital.go.cr/" target="_blank" rel="noopener noreferrer">
                <ListItemIcon><LocalPharmacy /></ListItemIcon>
                <ListItemText primary="RECETA DIGITAL" />
            </ListItem>
            <ListItem button component={Link} to="/agenda-diaria">
                <ListItemIcon><History /></ListItemIcon>
                <ListItemText primary="Agenda Diaria" />
            </ListItem>
                        <ListItem button component={Link} to="/agenda-medica">
                <ListItemIcon><History /></ListItemIcon>
                <ListItemText primary="Agenda Médica" />
            </ListItem>
        </List>
        </Box>
    );

    return (
        <>
            <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={() => setOpen(!open)}
            sx={{ position: 'fixed', top: 10, left: 10, zIndex: 1300, color: 'white'}} // Aseguramos el color blanco
            >
            <Menu />
            </IconButton>
            <SwipeableDrawer
                open={open}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
            >
                {drawerContent}
            </SwipeableDrawer>
            <Drawer
                open={open}
                onClose={toggleDrawer(false)}
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    width: 240,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: 240, boxSizing: 'border-box' },
                }}
            >
                {drawerContent}
            </Drawer>
        </>
    );
};

export default SideNav;
